import React from "react";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import "./Results.css";
import WhatsAppWidget from "../WhatsAppWidget/WhatsAppWidget";

const Results = () => {
  const navigate = useNavigate();
  const applicationId = localStorage.getItem("id") || "—";

  return (
    <div>
      {/* Top bar */}
      <DashboardHeader />

      {/* Content */}
      <div className="res">
        <div className="res__success">
          <div className="res__big">
            <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
              <path d="M5 12l5 5 9-10" />
            </svg>
          </div>
          <h1 className="res__title">Application submitted</h1>
          <p className="res__sub">Thank you for applying. A confirmation will be sent to your email.</p>
          <div>Your application ID</div>
          <div className="res__appid">{applicationId}</div>
          <p className="res__sub">Please save this ID. You will need it to check your status.</p>

          <button
            onClick={() => navigate("/application/instructions")}
            style={{
              marginTop: "24px",
              background: "#0f766e", color: "#fff", border: "none",
              borderRadius: "10px", padding: "14px 28px",
              fontWeight: 700, fontSize: "15px", cursor: "pointer",
            }}
          >
            Go to Application
          </button>
        </div>
      </div>
      <WhatsAppWidget />
    </div>
  );
};

export default Results;
